import { render, staticRenderFns } from "./SessionPersonOverlappings.vue?vue&type=template&id=e4452a58&"
import script from "./SessionPersonOverlappings.vue?vue&type=script&lang=js&"
export * from "./SessionPersonOverlappings.vue?vue&type=script&lang=js&"
import style0 from "./SessionPersonOverlappings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports